import { useEffect, useState } from "react";

const LOGOS = [
  { name: "The Pinnacle Companies", src: "/brands/tpc-logo-white.png" },
  { name: "Collective Architecture", src: "/brands/ca-logo-white.png" },
  { name: "Pinnacle Mountain Homes", src: "/brands/pmh-logo-white.png" },
  { name: "Collective Design", src: "/brands/cd-logo-white.png" },
];

const MOBILE_QUERY = "(max-width: 760px)";
const CYCLE_MS = 3800;
const TRANSITION_MS = 800;

export default function HeroBrandLogos() {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);
  const [reduceMotion, setReduceMotion] = useState(false);
  const [slide, setSlide] = useState({ current: 0, previous: -1, cycle: 0 });

  useEffect(() => {
    const mobile = window.matchMedia(MOBILE_QUERY);
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const syncMobile = () => setIsMobile(mobile.matches);
    const syncMotion = () => setReduceMotion(motion.matches);
    syncMobile();
    syncMotion();
    mobile.addEventListener?.("change", syncMobile);
    motion.addEventListener?.("change", syncMotion);
    return () => {
      mobile.removeEventListener?.("change", syncMobile);
      motion.removeEventListener?.("change", syncMotion);
    };
  }, []);

  useEffect(() => {
    if (!isMobile || reduceMotion) return;
    setSlide({ current: 0, previous: -1, cycle: 0 });
    const timer = window.setInterval(() => {
      setSlide((state) => ({
        current: (state.current + 1) % LOGOS.length,
        previous: state.current,
        cycle: state.cycle + 1,
      }));
    }, CYCLE_MS);
    return () => window.clearInterval(timer);
  }, [isMobile, reduceMotion]);

  if (!isMobile || reduceMotion) {
    return (
      <div className={`portal-hero__brands${isMobile ? " portal-hero__brands--mobile" : ""}`}>
        {LOGOS.map((logo) => (
          <img
            key={logo.src}
            className="portal-hero__brand-logo"
            src={logo.src}
            alt={logo.name}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="portal-hero__brand-carousel" aria-label="The Pinnacle Companies brands">
      {slide.previous >= 0 && (
        <div
          key={`leave-${slide.cycle}`}
          className="portal-hero__brand-slide portal-hero__brand-slide--leave"
          style={{ animationDuration: `${TRANSITION_MS}ms` }}
          aria-hidden="true"
        >
          <img src={LOGOS[slide.previous].src} alt="" />
        </div>
      )}
      <div
        key={`enter-${slide.cycle}`}
        className="portal-hero__brand-slide portal-hero__brand-slide--enter"
        style={{ animationDuration: `${TRANSITION_MS}ms` }}
      >
        <img src={LOGOS[slide.current].src} alt={LOGOS[slide.current].name} />
      </div>
    </div>
  );
}
